import { Navigate } from 'react-router';
import { useAuth } from '../hooks/useAuth';

export function Register() {
  const { isAuthenticated, isLoading, login } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-surface-dark">
        <div className="w-10 h-10 border-3 border-brand border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // If already authenticated, go to onboarding
  if (isAuthenticated) {
    return <Navigate to="/onboarding" replace />;
  }

  // Trigger B2C signup flow
  login();

  return (
    <div className="flex items-center justify-center min-h-screen bg-surface-dark">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-brand border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-400 text-sm">Redirecting to sign up...</p>
      </div>
    </div>
  );
}
